module.exports = __webpack_public_path__ + "img/sup_register_5.09b06135.png";